import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useImages } from '../../hooks/useImages';

export default function Image({
    src,
    alt,
    className,
    width,
    height,
    onClick
}) {
    const { handleImages } = useImages()
    const image = handleImages(src)
    return (
        <>
            {typeof image === 'string' ?
                <img
                    className={className}
                    src={image}
                    alt={alt}
                    width={width}
                    height={height}
                    onClick={onClick}
                /> :
            image ?
                <GatsbyImage
                    image={image}
                    alt={alt ? alt : 'img'}
                    className={className}
                    onClick={onClick}
                /> : null
            }  
        </>
    );
}
